var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "feedback-entry",
          class: { "feedback-entry--collapsed": _vm.isScrolling },
          on: { click: _vm.handleFeedback },
        },
        [_vm._m(0)]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "feedback-entry__btn" }, [
      _c("div", { staticClass: "feedback-entry__text" }, [_vm._v("反馈")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }